import { Typography, Box, Tooltip, IconButton, Grid } from "@mui/material";
import { colors } from "../theme";
import InfoIcon from "@mui/icons-material/Info";

const Header = ({ title, subtitle, desc }) => {

  return (
    <Grid container alignItems="center" gap='20px'>
    {desc && (
      <Grid >
        <Tooltip
          title={
            <Typography variant="body2" sx={{ fontSize: 15, padding: '0.5rem' }}>
              {desc}
            </Typography>
          }
          sx={{ justifyContent: "left" }}
        >
          <IconButton
            sx={{
              backgroundColor: "#2A354A",
              "&:hover": { backgroundColor: "#3c4d63" },
            }}
          >
            <InfoIcon sx={{ fontSize: 15 }} />
          </IconButton>
        </Tooltip>
      </Grid>
    )}

    <Grid >
      <Box display="flex" alignItems="center">
        <Typography
          variant="h2"
          color={colors.grey[100]}
          fontWeight="bold"
          sx={{ m: "0 8px 5px 0" }} // Aggiungi uno spazio a destra del titolo
          className="titleToPrint"
        >
          {title}
        </Typography>
      </Box>

      <Typography variant="h5" color={colors.greenAccent[400]}>
        {subtitle}
      </Typography>
    </Grid>
  </Grid>
  );
};

export default Header;
